import rangy from 'rangy';
import 'rangy/lib/rangy-classapplier';

const rangyService = {
    initialized: false,

    getRangy() {
        if (!this.initialized) {
            rangy.init();
            this.initialized = true;
        }
        return rangy;
    },
};

export default rangyService;
